webModule.directive('uiProviderFeature', function() {
    return {
        templateUrl: 'app/modules/web/directives/ui-provider-feature-directive.html',
        replace: true,
        restrict: 'E',
        scope: {
            featureName: '@featureName',
            model: '=model'
        },
        controller: ['$scope', 'providerFeaturesService', 'providerFeatureEvents', 'TLCError','AppErrorCodes',
            function($scope, providerFeaturesService, providerFeatureEvents, TLCError, AppErrorCodes) {
            var strategyType = 'UI';
            $scope.featureMetadata = [];

            providerFeaturesService.getFeatureMetadata(strategyType, $scope.featureName)
            .then(function(featureData) {
                $scope.featureMetadata = angular.fromJson(featureData);


                for(var featureIndex = 0; featureIndex < $scope.featureMetadata.length; featureIndex++) {
                    var feature = $scope.featureMetadata[featureIndex];

                    if(feature.Datasource) {
                        providerFeaturesService.getFeatureData(feature.Datasource, $scope.featureName)
                            .then(function (featureData) {
                                feature.data = featureData;
                            }, function (errorMsg) {
                                throw new TLCError(new Error("Error retrieving form data: " + errorMsg),AppErrorCodes.Global_Unknown);
                            });
                    }
                }

                var args = {validator: getDataValidator($scope.featureMetadata)};
                $scope.$emit(providerFeatureEvents.metaDataRetrieved, args);

            }, function(errorMsg) {
                throw new TLCError(new Error(errorMsg),AppErrorCodes.Global_Unknown);
            });

            var getDataValidator = function(metaDataList) {
                var validator = function(data) {
                    var isComplete = true;
                    for(var i = 0; i < metaDataList.length; i++) {
                        isComplete = isComplete && data.hasOwnProperty(metaDataList[i].Field) && data[metaDataList[i].Field];
                    }

                    return isComplete && true; // force boolean result rather than final data value
                };

                return validator;
            };
        }]
    };
});